var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4189 14.7321C20.4189 18.3101 18.3099 20.4191 14.7319 20.4191H6.94991C3.36291 20.4191 1.24991 18.3101 1.24991 14.7321V6.93212C1.24991 3.35912 2.56391 1.25012 6.14291 1.25012H8.14291C8.86091 1.25112 9.53691 1.58812 9.96691 2.16312L10.8799 3.37712C11.3119 3.95112 11.9879 4.28912 12.7059 4.29012H15.5359C19.1229 4.29012 20.4469 6.11612 20.4469 9.76712L20.4189 14.7321Z",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48102 13.463H15.216",
    stroke: "#C1C6D3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure);
export default __webpack_public_path__ + "static/media/procedure.f1d609c56217c11c620960a0f55ca007.svg";
export { ForwardRef as ReactComponent };